import { useEffect, useState } from "react";

const NAV_LINKS = [
  { key: "archive", label: "追踪档案" },
  { key: "focus", label: "四大追问" },
  { key: "index", label: "线索索引" },
  { key: "timeline", label: "舆情脉络" },
  { key: "credibility", label: "可信度" },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "fixed inset-x-0 top-0 z-40 transition-colors duration-300 " +
        (scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-transparent")
      }
    >
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-4 px-4 py-4 md:px-6 md:py-5">
        {/* Brand */}
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-user-search-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-black tracking-wide text-foreground-950">
              四一爆料
            </span>
            <span className="mt-1 font-label text-[11px] uppercase tracking-[0.28em] text-foreground-600">
              Identity Index
            </span>
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map((l) => (
            <a
              key={l.key}
              href={`#${l.key}`}
              className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <span className="hidden items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900 xl:flex">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
            线索持续整理中
          </span>
          <a
            href="#index"
            className="whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            进入线索合集
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          type="button"
          aria-label="切换菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-900 lg:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {/* Mobile panel */}
      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-6 pt-2 lg:hidden">
          <nav className="flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.key}
                href={`#${l.key}`}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <a
            href="#index"
            onClick={() => setOpen(false)}
            className="mt-3 block whitespace-nowrap rounded-md bg-foreground-950 px-4 py-3 text-center text-sm font-semibold text-background-50"
          >
            进入线索合集
          </a>
        </div>
      )}
    </header>
  );
}

export default Navbar;